import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/features/auth/useAuth';
import { getMustChangePassword } from '@/features/auth/currentUser';
import { LoadingSpinner } from '@/components/LoadingSpinner';

export function ProtectedLayout() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <LoadingSpinner message="Authenticating..." />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (getMustChangePassword()) {
    return <Navigate to="/change-password" replace />;
  }

  return <Outlet />;
}
